import { FC, useState, type ReactNode, type SyntheticEvent } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface TabItem {
  header?: { text?: string };
  content?: () => ReactNode;
}

interface TabBarComponentProps {
  items?: TabItem[];
  selectedItem?: number;
  selecting?: (args: { selectingIndex: number }) => void;
}

const TabBarComponent: FC<TabBarComponentProps> = ({ items = [], selectedItem = 0, selecting }) => {
  const [activeIndex, setActiveIndex] = useState(selectedItem);

  const handleChange = (_: SyntheticEvent, newIndex: number) => {
    if (selecting) selecting({ selectingIndex: newIndex });
    setActiveIndex(newIndex);
  };

  const activeItem = items[activeIndex];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Tabs value={activeIndex} onChange={handleChange}>
        {items.map((item, index) => (
          <Tab key={index} label={item.header?.text ?? `Tab ${index + 1}`} />
        ))}
      </Tabs>
      {activeItem?.content && <div>{activeItem.content()}</div>}
    </div>
  );
};

TabBarComponent.displayName = "TabBarComponent";
export default TabBarComponent;
